"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const renderer_1 = require("@react-pdf/renderer");
const styles = renderer_1.StyleSheet.create({
    headerContainer: {
        marginTop: 50,
    },
    companyInfo: {
        fontSize: 9,
    },
});
const BillTo = ({ invoice }) => (react_1.default.createElement(renderer_1.View, { style: styles.headerContainer },
    react_1.default.createElement(renderer_1.Text, null, invoice.company),
    react_1.default.createElement(renderer_1.Text, null, invoice.address),
    react_1.default.createElement(renderer_1.Text, null,
        "Tel. : ",
        invoice.phone),
    react_1.default.createElement(renderer_1.Text, null,
        "E-mail : ",
        invoice.email)));
exports.default = BillTo;
